import Product from "@/views/dashboard/models/Product";
export default {
  create_product_btn: 'إنشاء منتوج جديد',
  create_product_by_ai_btn: 'إنشاء منتوج بالدكاء الإصطناعي',
  filter: {
    search: {
      placeholder: 'تصفية المنتجات ...'
    },
    country: {
      placeholder: 'كل البلدان'
    },
    warehouse: {
      placeholder: 'جميع المستودعات'
    },
    sort: {
      new_to_old: ' من الجديد إلى القديم',
      old_to_new: 'من القديم إلى الجديد'
    },
    sort_archived: {
      show_archived: 'عرض مؤرشف',
      hide_archived: 'إخفاء المؤرشفة'
    }
  },
  tabs: {
    product_id: 'معرف المنتج : {id}',
    overview: 'نظرة عامة',
    inventory: 'المخزون',
    inventory_history: 'تاريخ المخزون',
    inventory_overview: 'نظرة عامة على المخزون'
  },
  product_item: {
    advertiser: 'معلن',
    warehouse: 'مستودع',
    available_in: 'متوفر في',
    buttons: {
      overview: 'النظرة العامة',
      add_inventory: 'إضافة المخزون',
      edit: 'تعديل',
      delete: 'حذف'
    }
  },
  dialogs: {
    delete: {
      title: 'حذف المنتوج',
      content: 'سيؤثر إيقاف المنتوج مؤقتًا أو حذفه على صفحات البيع المرتبطة به. هل انت متأكد انك تريد المتابعة ؟'
    }
  },
  ai_form: {
    description: 'سنستخدم الذكاء الاصطناعي لمسح عنوان URL للمنتج وسنعمل على إنشاء وصف جيد مع صور المنتج.',
    select_platform: 'الرجاء تحديد منصة المنتج وإدخال عنوان URL.',
    coming_soon: 'قريبا',
    fields: {
      description_language: {
        title: 'لغة الوصف',
        options: {
          ar: 'العربية',
          en: 'الإنجليزية',
          fr: 'الفرنسية',
          es: 'الإسبانية',
          it: 'الإطالية'
        }
      }
    },
    buttons: {
      plan_incentives_text: '{tries} منتجات مستوردة!',
      plan_incentives_tries_left: '{tries} متبقية',
      plan_incentives_button: 'قم بالترقية الآن',
      import_product: 'حفظ المنتج',
      close: 'إغلاق'
    }
  },
  form: {
    variant_types: {
      [Product.SINGLE_VARIANT_TYPE]: 'بدون أنواع',
      [Product.MULTIPLE_VARIANT_TYPE]: 'إضافة نوع'
    },
    toggle_form: 'انقر هنا لإنشاء منتج.',
    create_product: {
      title: 'إنشاء منتج',
      subtitle: 'إنشاء منتج جديد'
    },
    update_product: {
      title: 'تعديل المنتج',
      subtitle: 'تعديل المنتج'
    },
    create_btn: 'إنشاء منتج',
    save_btn: 'حفظ المنتج',
    cancel_btn: 'الغاء',
    duplicate_btn: 'نسخ المنتج',
    edit_btn: 'تعديل المنتج',
    delete_btn: 'حذف المنتج',
    step_one: 'الخطوة 1: معلومات المنتج',
    step_two: 'الخطوة 2: أضف مخزونًا لكل دولة',
    step_two_variant: 'الخطوة 2 : إضافة أنواع',
    variation_form: {
      table_filter: {
        select: 'إختر',
        all: 'الكل',
        none: 'لاشيء'
      },
      fields: {
        variation_name: 'إسم النوع',
        variation_options: {
          title: 'خيارات النوع',
          hint: 'يمكنك اختيار خيار من القائمة أو إضافة خيار جديد.'
        }
      },
      table: {
        image: 'الصورة',
        options: 'الخيارات',
        sku: 'Sku',
        quantity: 'الكمية',
        unit_price: 'سعر الوحدة',
        status: 'الحالة'
      },
      buttons: {
        add_variant: 'إضافة نوع آخر'
      }
    },
    fields: {
      image: {
        title: 'الصورة الرئيسة للمتجر'
      },
      name: {
        title: 'اسم المنتج',
        placeholder: 'اكتب اسم المنتج'
      },
      description: {
        title: 'وصف المنتج',
        placeholder: 'اكتب وصف المنتج'
      },
      gallery: {
        title: 'صور إضافية للمنتج'
      },
      status: {
        title: 'حالة المنتج'
      },
      private_note: {
        title: 'ملاحظات خاصة',
        placeholder: 'أكتب ملاحظاتك الخاصة'
      },
      sku: {
        title: 'Sku',
        placeholder: 'أكتب Sku'
      },
      advertiser: {
        title: 'المعلن',
        placeholder: 'حدد المعلن',
        no_advertiser_option: 'من غير معلن'
      },
      warehouse: {
        title: 'المستودع',
        placeholder: 'حدد المستودع'
      },
      country: {
        title: 'بلد البيع',
        tooltip: 'في أي بلد تريد بيع هذا المنتج؟',
        placeholder: 'حدد بلد المخزون'
      },
      inventory_quantity: {
        title: 'كمية المخزون',
        placeholder: 'قم بتعيين كمية المخزون'
      },
      inventory_cost: {
        title: 'التكلفة الوحدوية للمخزون',
        placeholder: 'حدد التكلفة الوحدوية للمخزون'
      }
    }
  },
  product_overview: {
    advertiser: 'المعلن',
    product_doesnt_have_advertiser: 'هذا المنتج ليس له معلن',
    short_description: 'وصف قصير',
    status: 'الحالة',
    warehouse: 'المستودع',
    available_in: 'متوفر في',
    private_note: {
      title: 'الملاحظات الخاصة',
      not_found: 'ليس لديك أي ملاحظات خاصة.'
    },
    variations: 'الأنواع'
  },
  inventory: {
    dialogs: {
      delete: {
        title: 'حذف المغزون',
        content: 'سيؤثر إيقاف المغزون مؤقتًا أو حذفه على العناصر المرتبطة به. هل انت متأكد انك تريد المتابعة ؟'
      }
    },
    form: {
      fields: {
        variation: {
          title: 'النوع'
        },
        country: {
          title: 'الدولة',
          placeholder: 'حدد بلد المخزون'
        },
        quantity: {
          title: 'كمية المخزون',
          placeholder: 'قم بتعيين كمية المخزون'
        },
        unitary_cost: {
          title: 'تكلفة المخزون',
          placeholder: 'حدد تكلفة المخزون'
        }
      },
      buttons: {
        create: 'إنشاء المخزون'
      }
    },
    table: {
      date: 'التاريخ',
      country: 'البلد',
      sku: 'Sku',
      quantity: 'الكمية',
      cost: 'التكلفة',
      unit_cost: 'تكلفة الوحدة',
      actions: 'خيارات'
    }
  },
  inventory_history: {
    total: 'المجموع',
    table: {
      date_time: 'التاريخ والوقت (N-O)',
      country: 'البلد',
      sku: 'Sku',
      quantity: 'الكمية',
      cost: 'التكلفة',
      unit_cost: 'تكلفة الوحدة',
      deleted_at: 'تم الحذف في',
      actions: 'اجراءات'
    }
  },
  inventory_overview: {
    total: 'المجموع',
    table: {
      sku: 'Sku',
      country: 'البلد',
      available_quantity: 'الكمية المتوفرة',
      last_daily_sales: 'آخر المبيعات اليومية',
      last_weekly_sales: 'آخر المبيعات الأسبوعية',
      out_of_stock: 'نفذ من المخزون في'
    }
  }
};